export default "__VITE_PUBLIC_ASSET__e2a2216e__"